module.exports = __webpack_public_path__ + "fonts/KFOkCnqEu92Fr1MmgVxHIzIFKw.ef7b5221.woff2";